export default {
  micro: 320,
  small: 480,
  medium: 768,
  large: 1024
};
